<template>
  <div class="question-bank-con">
    <div class="main">
      <!-- 左边导航 -->
      <div id="question-bank-nav-bar" class="nav-bar">
        <el-tabs @tab-click="tabCurrentType" value="first" :stretch="true">
          <el-tab-pane label="按章节" name="first">
            <NavBarList v-if="currentType" @selectOption="selectOption" :currentType="currentType" />
          </el-tab-pane>

          <el-tab-pane label="按知识点" name="second">
            <NavBarList v-if="!currentType" @selectOption="selectOption" :currentType="currentType" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 右边展示内容 -->
      <div class="main-view">
        <div class="type-nav">
          <TypeNav @typeObj="typeObj" :currentType="currentType" :ptypeDataList="ptypeDataList" :qtypeDataList="qtypeDataList" :diffDataList="degreeNavList" />
        </div>

        <!-- 展示内容 -->
        <div class="content-list">
          <QuestionBankList :loading="loading" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="拼命加载中" :testBankData="questionBankData" />

          <!-- 页码 -->
          <div class="page-num">
            <PageNum :pageTotal="pageTotal" @currentChange="currentChangePage" :currentPage1.sync="currentPage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//api获取--------------------------------------------
import { getDictBatch, getChapterTree, selectQuestion } from "@/network/resourceRequest/api";

//侧边导航--------------------------------------------
import NavBarList from "@/views/questionBankCenter/components/questionBank/components/NavBarList";
//类型导航--------------------------------------------
import TypeNav from "@/views/questionBankCenter/components/questionBank/components/TypeNav";
//页码--------------------------------------------
import PageNum from "@/components/common/PageNum";
//类型筛选--------------------------------------------
// import TypeNav from "@/components/common/TypeNav";
//难度筛选--------------------------------------------
import RadioNav from "@/components/common/RadioNav";
//内容展示--------------------------------------------
import QuestionBankList from "./components/QuestionBankList";

export default {
  name: "QuestionBankCon",
  components: {
    NavBarList,
    TypeNav,
    PageNum,
    RadioNav,
    QuestionBankList
  },
  data() {
    return {
      //当前类型 true章节 false知识点
      currentType: true,

      //题目数据
      questionBankData: {
        list: []
      },

      //筛选的条件
      fd: {},

      //当前页码--------------------------------------------
      currentPage: 1,
      //页码总数量
      pageTotal: 0,

      //题库类型导航数组
      ptypeDataList: [],

      //题型选择
      qtypeDataList: [],

      //难度导航数组
      degreeNavList: [{ name: "全部" }, { name: "易" }, { name: "较易" }, { name: "中档" }, { name: "较难" }, { name: "难" }],

      //是否显示loading
      loading: false
    };
  },

  created() {
    //初始化筛选列表
    this.getSelectData();
  },

  methods: {
    //获取筛选字典数据
    async getSelectData() {
      //默认筛选条件
      this.fd.pageNum = 1;
      this.fd.pageSize = 10;

      //course科目,phase学段,grade年级,volume册别,edition教材版本,qtype题型,bookType类型,ptype
      let data = {
        types: "qtype,ptype"
      };

      let dict = await getDictBatch(data);
      //获取学段年级科目数据字典

      //类型
      let resultInfo = dict.data.data;
      this.ptypeDataList.push({
        name: "全部"
      });
      resultInfo &&
        resultInfo.ptype.forEach(item => {
          this.ptypeDataList.push({
            label: item.name,
            name: item.name
          });
        });

      //题型--------------------------------------------
      this.qtypeDataList.push({
        name: "全部"
      });

      resultInfo &&
        resultInfo.qtype.forEach(item => {
          this.qtypeDataList.push({
            name: item.name,
            label: item.name
          });
        });
      this.getQuestionBank(this.fd, 1);
    },

    //侧边筛选数据
    selectOption(data, id, option) {
      if (data.length != 0) {
        if (this.currentType) {
          this.fd.knowledgeId && delete this.fd.knowledgeId;
          this.$set(this.fd, "chapterId", id);
        } else {
          this.fd.chapterId && delete this.fd.chapterId;
          this.$set(this.fd, "knowledgeId", id);
        }
        this.getQuestionBank(this.fd, 1);
      } else {
        this.loading = false;
        this.questionBankData = {
          list: []
        };
        this.pageTotal = 0;
      }
    },

    //类型筛选条件
    typeObj(e) {
      this.fd.ptype && delete this.fd.ptype;
      this.fd.qtype && delete this.fd.qtype;
      this.fd.diff && delete this.fd.diff;

      for (const key in e) {
        if (e.hasOwnProperty(key)) {
          if (key == "diff") {
            let diff;
            switch (e[key]) {
              case "易":
                diff = 1;
                break;
              case "较易":
                diff = 2;
                break;
              case "中档":
                diff = 3;
                break;
              case "较难":
                diff = 4;
                break;
              case "难":
                diff = 5;
                break;
              default:
                diff = 0;
                break;
            }
            const element = diff;
            this.$set(this.fd, key, element);
          } else {
            if (e[key] == "全部") {
              delete this.fd[key];
            } else {
              const element = e[key];
              this.$set(this.fd, key, element);
            }
          }
        }
      }

      this.getQuestionBank(this.fd, 1);
    },

    //页码筛选--------------------------------------------
    currentChangePage(newPage) {
      this.getQuestionBank(this.fd, newPage);
    },

    //根据条件获取数据
    getQuestionBank(fd, page) {
      console.log(121312132);
      this.fd.pageNum = page;
      this.currentPage = page;
      this.fd.pageSize = 10;
      this.loading = true;
      selectQuestion(fd).then(res => {
        console.log(121312132, res);
        if (res.data.success) {
          this.loading = false;
          this.questionBankData = res.data.data ? res.data.data : {};
          this.pageTotal = res.data.data ? Number(res.data.data.total) : 0;
        } else {
          this.loading = false;
        }
      });
    },

    //当前的tab
    tabCurrentType(e) {
      if (e.name == "second") {
        this.currentType = false;
        this.fd = {};
        this.getQuestionBank(this.fd, 1);
      }
      if (e.name == "first") {
        this.currentType = true;
        this.fd = {};
        this.getQuestionBank(this.fd, 1);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.question-bank-con {
  padding-top: 5px;

  .main {
    display: flex;

    margin: 0 auto;
    width: 1200px;
    min-height: 1200px;

    justify-content: space-between;

    // 左边导航
    .nav-bar {
      border-radius: 5px;
      width: 235px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;

      /deep/.el-tabs {
        height: 100%;
        overflow: visible;
        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__item {
          padding: 0 !important;
        }

        .el-tabs__item.is-active.is-active.is-active {
          &#tab-first {
            color: #fff;
            background-color: #24ba58;
            border-top-left-radius: 5px;
          }

          &#tab-second {
            color: #fff;
            background-color: #24ba58;
            border-top-right-radius: 5px;
          }
        }

        .el-tabs__active-bar.el-tabs__active-bar {
          opacity: 0;
        }

        .el-tabs__content {
          height: 100%;
          overflow: visible;
        }
        .el-tabs__item {
          height: 60px;
          line-height: 60px;
        }

        .el-tabs__nav-wrap::after {
          height: 1px;
        }

        .el-tabs__active-bar {
          height: 1px;
        }
      }
    }

    //内容
    .main-view {
      border-radius: 5px;
      width: 960px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;

      .type-nav {
        display: flex;

        position: relative;

        border-bottom: 1px solid rgba(229, 229, 229, 1);
        padding-left: 20px;
        height: 60px;

        align-items: flex-end;
      }

      .content-list {
        padding: 0 20px 20px;

        background-color: #fff;

        /deep/ .el-loading-mask {
          top: 130px;
        }

        /deep/ .el-loading-spinner {
          top: 0 !important;
        }

        /deep/ .el-loading-spinner i {
          color: #24ba58 !important;
        }

        /deep/ .el-loading-spinner .el-loading-text {
          color: #24ba58 !important;
        }

        .page-num {
          display: flex;

          margin: 20px 0;

          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
